module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showDismissibleAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showDismissibleAlert = false
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.messageAlert) + "\n  ")])], 1), _vm._v(" "), (_vm.exibirGraficoProducao) ? _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Monitoramentos (%)")]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.relatorios.producao
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.exibirGraficoTag) ? _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Produção (%)")]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.relatorios.tag
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.exibirGraficoTag) ? _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', _vm._l((_vm.relatorios.tabela), function(data, index) {
    return _c('th', {
      key: index
    }, [_vm._v(_vm._s(index))])
  }))]), _vm._v(" "), _c('tbody', [_c('tr', _vm._l((_vm.relatorios.tabela), function(data, index) {
    return _c('td', {
      key: index
    }, _vm._l((data), function(valor, campo) {
      return _c('p', {
        key: campo
      }, [_c('strong', [_vm._v(_vm._s(campo) + ": ")]), (campo === 'Total') ? _c('span', {
        staticClass: "label label-success"
      }, [_vm._v(_vm._s(valor))]) : _c('span', {
        staticClass: "label label-default"
      }, [_vm._v(_vm._s(valor))])])
    }))
  }))])])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.exibirGraficoDesempenho) ? _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Produção (%)")]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.relatorios.desempenho
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.exibirGraficoDesempenho) ? _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _vm._l((_vm.relatorios.tabeladesempenho), function(data, index) {
    return _c('th', {
      key: index
    }, [_vm._v(_vm._s(index))])
  })], 2)]), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(4), _vm._v(" "), _vm._l((_vm.relatorios.tabeladesempenho), function(data, index) {
    return _c('td', {
      key: index
    }, [_vm._v("\n                        " + _vm._s(data.total) + "\n                      ")])
  })], 2), _vm._v(" "), _c('tr', [_vm._m(5), _vm._v(" "), _vm._l((_vm.relatorios.tabeladesempenho), function(data, index) {
    return _c('td', {
      key: index
    }, [_vm._v("\n                        " + _vm._s(data.qtdPedidos) + "\n                      ")])
  })], 2), _vm._v(" "), _c('tr', [_vm._m(6), _vm._v(" "), _vm._l((_vm.relatorios.tabeladesempenho), function(data, index) {
    return _c('td', {
      key: index
    }, [_vm._v("\n                        " + _vm._s(data.horasoperando) + "\n                      ")])
  })], 2), _vm._v(" "), _c('tr', [_vm._m(7), _vm._v(" "), _vm._l((_vm.relatorios.tabeladesempenho), function(data, index) {
    return _c('td', {
      key: index
    }, [_vm._v("\n                        " + _vm._s(data.tempoutil) + "\n                      ")])
  })], 2)])])])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('h3', [_vm._v("Requisitos de pesquisa")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Data Inicial")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Selecione a data inicial",
      "id": "dataInicioBusca",
      "language": _vm.ptBR
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Data Final")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Selecione a data final",
      "id": "dataFimBusca",
      "language": _vm.ptBR
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group col-sm-4"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "checkbox",
    attrs: {
      "id": "dados"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.isDadosOperando),
      expression: "pesquisa.isDadosOperando"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.pesquisa.isDadosOperando) ? _vm._i(_vm.pesquisa.isDadosOperando, null) > -1 : (_vm.pesquisa.isDadosOperando)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.pesquisa.isDadosOperando,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.pesquisa.isDadosOperando = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.pesquisa.isDadosOperando = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.pesquisa, "isDadosOperando", $$c)
        }
      }
    }
  }), _vm._v("\n                  Operando\n                ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.isDadosFuncao),
      expression: "pesquisa.isDadosFuncao"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.pesquisa.isDadosFuncao) ? _vm._i(_vm.pesquisa.isDadosFuncao, null) > -1 : (_vm.pesquisa.isDadosFuncao)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.pesquisa.isDadosFuncao,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.pesquisa.isDadosFuncao = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.pesquisa.isDadosFuncao = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.pesquisa, "isDadosFuncao", $$c)
        }
      }
    }
  }), _vm._v("\n                  Função\n                ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.isDadosOutros),
      expression: "pesquisa.isDadosOutros"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.pesquisa.isDadosOutros) ? _vm._i(_vm.pesquisa.isDadosOutros, null) > -1 : (_vm.pesquisa.isDadosOutros)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.pesquisa.isDadosOutros,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.pesquisa.isDadosOutros = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.pesquisa.isDadosOutros = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.pesquisa, "isDadosOutros", $$c)
        }
      }
    }
  }), _vm._v("\n                  Demais Operações\n                ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.isDadosDisponiveis),
      expression: "pesquisa.isDadosDisponiveis"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.pesquisa.isDadosDisponiveis) ? _vm._i(_vm.pesquisa.isDadosDisponiveis, null) > -1 : (_vm.pesquisa.isDadosDisponiveis)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.pesquisa.isDadosDisponiveis,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.pesquisa.isDadosDisponiveis = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.pesquisa.isDadosDisponiveis = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.pesquisa, "isDadosDisponiveis", $$c)
        }
      }
    }
  }), _vm._v("\n                  Disponível\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "maquinas"
    }
  }, [_vm._v("Máquina")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.idcontrolador),
      expression: "pesquisa.idcontrolador"
    }],
    staticClass: "form-control col-sm-4",
    attrs: {
      "id": "maquinas"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.pesquisa, "idcontrolador", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Selecione a Máquina")]), _vm._v(" "), _vm._l((_vm.monitores), function(monitor) {
    return _c('option', {
      key: monitor.id,
      domProps: {
        "value": monitor.idcontrolador
      }
    }, [_vm._v(_vm._s(monitor.nomemaquina))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "turnos"
    }
  }, [_vm._v("Turno")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.idTurnoSelecionado),
      expression: "pesquisa.idTurnoSelecionado"
    }],
    staticClass: "form-control col-sm-4",
    attrs: {
      "id": "turnos"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.pesquisa, "idTurnoSelecionado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Selecione o Turno")]), _vm._v(" "), _vm._l((_vm.turnos), function(turno) {
    return _c('option', {
      key: turno.id,
      domProps: {
        "value": turno.id
      }
    }, [_vm._v(_vm._s(turno.nometurno))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "col-sm-2",
    attrs: {
      "v": ""
    }
  }, [(_vm.pesquisa.isDadosDisponiveis || _vm.pesquisa.isDadosOperando || _vm.pesquisa.isDadosFuncao || _vm.pesquisa.isDadosOutros) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.efetuarPesquisa()
      }
    }
  }, [_vm._v("\n              Efetuar Pesquisa\n            ")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("\n              Efetuar Pesquisa\n            ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Produção por código/tag")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Produção por código/tag")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Total Produzido")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Num Pedidos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Tempo Produzindo (h)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Turno (h)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-8 control-label",
    attrs: {
      "for": "dados"
    }
  }, [_vm._v("Tipo de Dados")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6af67fa0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/RelatoriosGerais.vue
// module id = 1577
// module chunks = 1